import { useMutation, useQuery } from '@tanstack/react-query'
import { exportMyPendencies, getMyPendencies } from '@/api/services/pendencies'
import type { PendenciesMeOutput, PendenciesMeParams } from '@/types/pendency'

const QUERY_KEY = ['pendencies', 'me']

export function useMyPendencies(params?: PendenciesMeParams) {
	return useQuery<PendenciesMeOutput, Error>({
		queryKey: [...QUERY_KEY, params],
		queryFn: () => getMyPendencies(params),
	})
}

export function useExportMyPendencies() {
	return useMutation({
		mutationFn: ({
			params,
			format,
		}: {
			params: PendenciesMeParams
			format: 'xlsx' | 'pdf'
		}) => exportMyPendencies(params, format),
	})
}
